import { api } from '@/shared/axios-client';

export interface ValidateCaptureUrlResponse {
  ok: boolean;
  error?: string;
  status_code?: number | null;
}

export interface EnableCaptureBody {
  frontendUrl: string;
  enabled?: boolean;
  optedInBy?: string;
  branch?: string;
  repositoryName?: string;
}

export const validateCaptureUrl = (
  url: string,
): Promise<ValidateCaptureUrlResponse> =>
  api.post('/api/capture/validate', { url });

export const enableRepositoryCapture = (
  repoId: string,
  body: EnableCaptureBody,
): Promise<{ ok: boolean; captureId?: string }> =>
  api.post(`/api/repositories/${repoId}/capture/enable`, {
    enabled: true,
    ...body,
  });

export const getRepositoryCapture = (repoId: string) =>
  api.get(`/api/repositories/${repoId}/capture`);

export const getRepositoryComparison = (repoId: string) =>
  api.get(`/api/repositories/${repoId}/comparison`);

export const triggerAfterCapture = (repoId: string) =>
  api.post(`/api/repositories/${repoId}/capture/after`);

export const triggerCompare = (repoId: string) =>
  api.post(`/api/repositories/${repoId}/compare`);
